/**
 * List of supported OAUTH providers.
 *
 * @type {{BLACKBAUD: string, PLIC: string}}
 */
const OAUTH_PROVIDERS = {
  BLACKBAUD: 'BLACKBAUD',
  PLIC: 'PLIC',
};

export { OAUTH_PROVIDERS };
